import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-splash-text',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="splash-text" [class.started]="start && !reducedMotion" [class.static]="reducedMotion"
      (animationend)="finish()">{{ text }}</span>`,
  styles: [`
    :host { display:block; text-align:center; }
    .splash-text { display:inline-block; color:var(--ion-color-recog-lemon-shade); font-size:23px; font-weight:600; line-height:1.12; }
    .splash-text.started { color:transparent; background:linear-gradient(100deg, var(--ion-color-recog-lemon-shade) 0%, var(--ion-color-recog-lemon-shade) 38%, var(--ion-color-recog-sand) 49%, var(--ion-color-recog-sand) 51%, var(--ion-color-recog-lemon-shade) 62%, var(--ion-color-recog-lemon-shade) 100%); background-size:240% 100%; background-position:100% 0; background-clip:text; -webkit-background-clip:text; animation:splash-glimmer 2600ms ease-out both; }
    .splash-text.static { color:var(--ion-color-recog-sand); }
    @keyframes splash-glimmer { to { background-position:0 0; } }
    @media(prefers-reduced-motion:reduce) { .splash-text.started { animation:none; color:var(--ion-color-recog-sand); } }
  `],
})
export class SplashTextComponent implements OnChanges, OnDestroy {
  @Input() text = '';
  @Input() start = false;
  @Input() playOnce = true;
  @Input() reducedMotion = typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  @Output() completed = new EventEmitter<void>();
  private hasCompleted = false;
  private reducedMotionTimer?: ReturnType<typeof setTimeout>;
  private fallbackTimer?: ReturnType<typeof setTimeout>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['start'] && this.start && !this.hasCompleted && this.reducedMotion) {
      this.reducedMotionTimer = setTimeout(() => this.finish(), 0);
    } else if (changes['start'] && this.start && !this.hasCompleted) {
      this.fallbackTimer = setTimeout(() => this.finish(), 2800);
    }
  }

  ngOnDestroy(): void {
    if (this.reducedMotionTimer) clearTimeout(this.reducedMotionTimer);
    if (this.fallbackTimer) clearTimeout(this.fallbackTimer);
  }

  finish(): void {
    if (this.hasCompleted || (this.playOnce && !this.start)) return;
    this.hasCompleted = true;
    if (this.reducedMotionTimer) clearTimeout(this.reducedMotionTimer);
    if (this.fallbackTimer) clearTimeout(this.fallbackTimer);
    this.completed.emit();
  }
}
